var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculatorSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,1H7C5.3457031,1,4,2.3457031,4,4v24c0,1.6542969,1.3457031,3,3,3h18c1.6542969,0,3-1.3457031,3-3V4 C28,2.3457031,26.6542969,1,25,1z M26,28c0,0.5517578-0.4482422,1-1,1H7c-0.5517578,0-1-0.4482422-1-1V4 c0-0.5517578,0.4482422-1,1-1h18c0.5517578,0,1,0.4482422,1,1V28z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 20,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 25,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 25,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 15,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19,
    width: 2,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,5H10C8.8974609,5,8,5.8974609,8,7v3c0,1.1025391,0.8974609,2,2,2h12c1.1025391,0,2-0.8974609,2-2V7 C24,5.8974609,23.1025391,5,22,5z M10,10V7h12l0.0019531,3H10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorSmall);
export default __webpack_public_path__ + "static/media/calculator--small.57d695950c5eb83bfbdf0f8bb7d2fd89.svg";
export { ForwardRef as ReactComponent };